import React from 'react';
import MegaMenuItem from '../MegaMenuItem';
import IndustrySubMenuFooter from './footer';
import { IndustrySubMenuContainer } from './styles';

const IndustrySubMenu = ({ isMenuOpened, setMobileMenuOpened, subNavElements = [] }) => {
  const menuItems = [
    {
      group: 'Industry',
      items: subNavElements.filter(item => item.group?.group === 'Industry'),
      className: 'group-industry',
    },
    {
      group: 'Business Type',
      items: subNavElements.filter(item => item.group?.group === 'Business Type'),
      className: 'group-business-type',
    },
    {
      group: 'Company Size',
      items: subNavElements.filter(item => item.group?.group === 'Company Size'),
      className: 'group-company-size',
    },
  ];

  const [footerMenuItem] = subNavElements.filter(item => item.group?.group === 'Footer');
  const groupCnt = menuItems.reduce((acc, cur) => acc + (cur.items?.length > 0 ? 1 : 0), 0);
  const industryGroupCols = groupCnt === 1 ? 3 : 2;
  const industryGroupRows = Math.ceil(menuItems[0].items.length / industryGroupCols);

  return (
    <IndustrySubMenuContainer
      className="mega-menu"
      isMenuOpened={isMenuOpened}
      industryGroupCols={industryGroupCols}
      industryGroupRows={industryGroupRows}
    >
      <div className="industry-sub-menu--container">
        {menuItems
          .filter(groupMenu => groupMenu.items.length > 0)
          .map((groupMenu, index) => (
            <div
              className={`industry-sub-menu--group-container ${groupMenu.className}`}
              key={index}
            >
              <p className="industry-sub-menu--sub-title">{groupMenu.group}</p>
              <ul className="industry-sub-menu--menu-content">
                {groupMenu.items.map((item, index1) => {
                  const { description, icon, label, url } = item;
                  return (
                    <MegaMenuItem
                      type="icon-title-desc"
                      icon={icon?.image?.file?.url}
                      alt={icon?.alt}
                      title={label}
                      link={url}
                      key={index1}
                      setMobileMenuOpened={setMobileMenuOpened}
                    >
                      {description}
                    </MegaMenuItem>
                  );
                })}
              </ul>
            </div>
          ))}
      </div>
      {footerMenuItem && <IndustrySubMenuFooter footerItem={footerMenuItem} />}
    </IndustrySubMenuContainer>
  );
};

export default IndustrySubMenu;
